import { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthenticatedUser } from '../../domain/users/authenticate-user';
import {
    localStorageService,
    authenticationService,
} from '../../infrastructure/services';
import { LocalStorage_keys, Public_Routes, Private_Routes } from '../constants';
import { AppContext } from '../context/Provider';

export default function UserMenu() {
    const { langResources, isSkinSmart } = useContext(AppContext);

    const [authenticatedUser, setAuthenticatedUser] = useState<AuthenticatedUser>();

    useEffect(() => {
        // if (localStorageService.get(LocalStorage_keys.USER_KEY, true)) {
        //     const user = localStorageService.get(LocalStorage_keys.USER_KEY, true);
        //     setAuthenticatedUser(user);
        // }
    }, []);

    const logout = () => {
        authenticationService.logout();
        document.location.href = Public_Routes.LOGIN;
    };

    return (
        <div
            className='dropdown ms-sm-3 header-item topbar-user '
            style={{
                height: 55,
                background: !isSkinSmart ? 'rgba(255,255,255,0.8)' : '#f3a87ab6',
            }}
        >
            <button
                type='button'
                className='btn'
                id='page-header-user-dropdown'
                data-bs-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
            >
                <span className='d-flex align-items-center'>
                    <img
                        className='rounded-circle header-profile-user'
                        src='/assets/images/user-dummy-img.jpg'
                        alt=''
                    />
                    <span className='text-start ms-xl-2' id='text-username'>
                        <span
                            className={`d-none d-xl-inline-block ms-1 fw-medium user-name-text ${
                                !isSkinSmart ? 'skinSiesa' : 'text-light'
                            }`}
                        >
                            {authenticatedUser?.firstName}
                        </span>
                    </span>
                </span>
            </button>

            <div className='dropdown-menu dropdown-menu-end'>
                <h6 className='dropdown-header'>
                    {langResources['header']['user.menu.options.title']}
                </h6>

                <Link className='dropdown-item' to={Private_Routes.PROFILE}>
                    <i className='mdi mdi-account-circle text-muted fs-16 align-middle me-1'></i>{' '}
                    <span className='align-middle'>
                        {langResources['header']['user.menu.options.profile.option']}
                    </span>
                </Link>

                <Link
                    className='dropdown-item'
                    onClick={logout}
                    to={Public_Routes.LOGIN}
                >
                    <i className='mdi mdi-logout text-muted fs-16 align-middle me-1'></i>{' '}
                    <span className='align-middle' data-key='t-logout'>
                        {langResources['header']['user.menu.options.logout.option']}
                    </span>
                </Link>
            </div>
        </div>
    );
}
